import {Injectable} from '@angular/core'
import {environment} from '../environments/environment'
import {HttpClient} from '@angular/common/http'
import {Order} from '../models/order';

const API = environment.API

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private http: HttpClient) {
  }

  createOrder(products: string[], referrals: string[], promotions: string[], referrerCode: string | null) {
    const body = {products, referrals, promotions, referrerCode}
    return this.http.post(`${API}/api/orders`, body)
  }

  createManualOrder(userId: string, products: string[], referrals: string[], promotions: string[], fixedAmount: number) {
    const body = {userId, products, referrals, promotions, fixedAmount}
    return this.http.post(`${API}/api/orders/manual`, body)
  }

  createSingleOrder(products: string[], referrals: string[], promotions: string[], referrerCode: string) {
    const body = {products, referrals, promotions, referrerCode}
    return this.http.post(`${API}/api/orders/single`, body)
  }

  createCompanyOrder(memberId: string, companyId: string, productIds: string[], promotionIds: string[]) {
    const body = {memberId, companyId, productIds, promotionIds}
    return this.http.post(`${API}/api/orders/company`, body)
  }

  createManualCompanyOrder(companyId: string, products: string[], fixedAmount: number) {
    const body = {companyId, products, fixedAmount}
    return this.http.post(`${API}/api/orders/company/manual`, body)
  }

  createTransactionOrder(transactionId: string) {
    const body = {transactionId}
    return this.http.post(`${API}/api/orders/transaction`, body)
  }

  createBookingOrder(productIds: string[], referralIds: string[], promotionIds: string[], placeId: string, roomId: string, localBegin: string, localEnd: string, expectedPrice: number) {
    const body = {productIds, referralIds, promotionIds, placeId, roomId, localBegin, localEnd, expectedPrice}
    return this.http.post(`${API}/api/orders/booking`, body)
  }

  createVerifyOrder(userId: string, companyId: string, productId: string) {
    const body = {userId, companyId, productId}
    return this.http.post(`${API}/api/orders/verify`, body)
  }

  getById(orderId: string) {
    return this.http.get<Order>(`${API}/api/orders/${orderId}`)
  }

  findByRange(begin: string, end: string, limit: number, skip: number) {
    const params = {begin, end, limit, skip}
    return this.http.get<Order[]>(`${API}/api/orders/range`, {params})
  }

  findByUser(limit: number, skip: number) {
    const params = {limit, skip}
    return this.http.get<Order[]>(`${API}/api/orders/user`, {params})
  }

  findByUserId(userId: string) {
    return this.http.get<Order[]>(`${API}/api/orders/user/${userId}`)
  }

  findByCompanyId(companyId: string, limit: number, skip: number) {
    const params = {limit, skip}
    return this.http.get<Order[]>(`${API}/api/orders/company/${companyId}`, {params})
  }

  findOrders() {
    return this.http.get<Order[]>(`${API}/api/orders`)
  }

  cancelBookingOrder(orderId: string) {
    return this.http.put(`${API}/api/orders/${orderId}/cancel/booking`, {})
  }

  refund(orderId: string, refundAmount: number) {
    const body = {refundAmount}
    return this.http.put(`${API}/api/orders/${orderId}/refund`, body)
  }

  receipt(orderId: string, email: string) {
    const body = {email}
    return this.http.put(`${API}/api/orders/${orderId}/receipt`, body)
  }

  emailCustomerBookingReceipt(orderId: string, email: string) {
    const body = {email}
    return this.http.put(`${API}/api/orders/${orderId}/receipt/booking/customer`, body)
  }

  emailMerchantBookingReceipt(orderId: string, email: string) {
    const body = {email}
    return this.http.put(`${API}/api/orders/${orderId}/receipt/booking/merchant`, body)
  }
}
